import { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader, StatusChip } from '@/components/core';
import { Button } from '@/components/ui-kit/button';
import { formatDateOnly } from '@/lib/utils/custom-date/custom-date';
import { SurveySubmission } from '../../types/submission.types';

const STATUSES = ['Pending', 'Completed'] as const;

interface CreateSubmissionsTableColumnsProps {
  t: (key: string) => string;
  onOpen: (submission: SurveySubmission) => void;
}

export const createSubmissionsTableColumns = ({
  t,
  onOpen,
}: CreateSubmissionsTableColumnsProps): ColumnDef<SurveySubmission>[] => [
  {
    id: 'SurveyTitle',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('SURVEY')} />,
    accessorFn: (row) => row.SurveyTitle ?? '-',
  },
  {
    id: 'Deadline',
    meta: { filter: { type: 'date' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('DEADLINE')} />,
    accessorFn: (row) => row.Deadline,
    cell: ({ row }) => formatDateOnly(row.original.Deadline) || '-',
  },
  {
    id: 'Status',
    meta: {
      filter: {
        type: 'options',
        options: STATUSES.map((status) => ({ value: status, label: t(status.toUpperCase()) })),
      },
    },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('STATUS')} />,
    accessorFn: (row) => row.Status,
    cell: ({ row }) => (
      <StatusChip status={row.original.Status}>{t(row.original.Status.toUpperCase())}</StatusChip>
    ),
  },
  {
    id: 'actions',
    // Card: top right, as the old portal's card header.
    meta: { mobile: 'badge' as const },
    header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => (
      <Button variant="outline" size="sm" onClick={() => onOpen(row.original)}>
        {row.original.Status === 'Completed' ? t('VIEW') : t('FILL_OUT')}
      </Button>
    ),
  },
];
